import { render, staticRenderFns } from "./InstitutionsServiceValue.html?vue&type=template&id=57356400&external"
import script from "./InstitutionsServiceValue.js?vue&type=script&lang=js&external"
export * from "./InstitutionsServiceValue.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports